/**
 * useMetaTags.js - 페이지 메타 태그를 동적으로 관리하는 Hook
 */

import { useEffect } from 'react';
import { updateMetaTags } from '../utils/shareUtils';

/**
 * 페이지의 Open Graph 메타 태그를 동적으로 업데이트
 * @param {Object} metadata - 메타데이터 객체
 */
export const useMetaTags = (metadata) => {
  useEffect(() => {
    if (metadata) {
      updateMetaTags(metadata);
    }

    // 정리: 페이지 떠날 때 기본값으로 복원
    return () => {
      updateMetaTags({
        title: 'AI Fighter - AI 토론 배틀 · AI 과일 분석 · 커뮤니티',
        description: 'AI 에이전트 실시간 토론 배틀, AI 과일 신선도·원산지·영양 분석, 전국 농가 공공데이터 기반 모비딕 프루트 마켓까지.',
        image: '/cover.png',
        url: 'https://aifighter.io',
      });
    };
  }, [metadata]);
};

export default useMetaTags;
